
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PromoCode } from "@/types/supabase";
import { Loader2 } from "lucide-react";

interface PromoCodeInputProps {
  onApply: (code: string) => void;
  appliedCode: PromoCode | null;
  isValidating?: boolean;
}

const PromoCodeInput = ({ onApply, appliedCode, isValidating = false }: PromoCodeInputProps) => {
  const [promoCode, setPromoCode] = useState("");

  const handleApply = () => {
    if (promoCode.trim()) {
      onApply(promoCode);
      setPromoCode("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleApply();
    }
  };

  return (
    <div className="border-t pt-4 mt-4">
      <div className="flex gap-2 mb-4">
        <Input
          placeholder="Code promo"
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isValidating}
        />
        <Button 
          onClick={handleApply} 
          disabled={!promoCode.trim() || isValidating}
        >
          {isValidating ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Vérification
            </>
          ) : (
            "Appliquer"
          )}
        </Button>
      </div>
      
      {appliedCode && (
        <div className="text-sm text-green-600 mb-4">
          Code promo appliqué : {appliedCode.code} 
          {appliedCode.discount_type === 'percentage' 
            ? ` (${appliedCode.discount_value}% de réduction)`
            : ` (${appliedCode.discount_value}€ de réduction)`
          }
        </div>
      )}
    </div>
  );
};

export default PromoCodeInput;
